/**
 * Grid codes of the labour catalogue. The page header of Labour operations sends its bulk actions
 * to the grid by this code, so both must use the same value.
 */
export const LABOUR_CATALOG_GRID_CODES = {
  labourCatalogItems: 'labour-catalog-items',
  basketLabourCatalog: 'basket-labour-catalog',
} as const;
